import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-category-s',
  templateUrl: './ddc-category-s.component.html',
  styleUrl: './ddc-category-s.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcCategorySComponent {
  @Input() label: string

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
